import { AxiosInstance } from "axios";
import authAxios from "../auth/auth.interceptor.service";

export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL;

export function getAuthAxiosInstance(): AxiosInstance {
  return authAxios;
}
